import activityCardHeader from 'components/ActivityCard/components/ActivityCardHeader/translations/english';
import applicationActivityList from 'components/ApplicationActivityList/translations/english';
import applicationsGridRow from 'components/ApplicationsGrid/components/ApplicationsGridRow/translations/english';
import applicationsGrid from 'components/ApplicationsGrid/translations/english';
import assetToggle from 'components/AssetToggle/translations/english';
import assetsGridRow from 'components/AssetsGrid/components/AssetsGridRow/translations/english';
import assetsGrid from 'components/AssetsGrid/translations/english';
import batteriesGrid from 'components/BatteriesGrid/translations/english';
import batteryCard from 'components/BatteryCard/translations/english';
import boundariesGrid from 'components/BoundariesGrid/translations/english';
import clientGrid from 'components/ClientGrid/translations/english';
import combobox from 'components/Combobox/translations/english';
import componentStatusRow from 'components/ComponentStatusRow/translations/english';
import dataTableDropdown from 'components/DataTableDropdown/translations/english';
import datePicker from 'components/DatePicker/translations/english';
import dateRangePickerInputs from 'components/DateRangePicker/components/DateRangePickerInputs/translations/english';
import dateRangePicker from 'components/DateRangePicker/translations/english';
import detailsViewCardApplicationList from 'components/DetailsViewCardApplicationList/translations/english';
import detailsViewCardApplicationListItem from 'components/DetailsViewCardApplicationListItem/translations/english';
import detailsViewCloseButton from 'components/DetailsViewCloseButton/translations/english';
import detailsViewEntityMenu from 'components/DetailsViewEntityMenu/translations/english';
import drawer from 'components/Drawer/translations/english';
import droneActivityLink from 'components/DroneCard/components/DroneActivityLink/translations/english';
import droneCardDetails from 'components/DroneCard/components/DroneCardDetails/translations/english';
import lastSynced from 'components/DroneCard/components/LastSynced/translations/english';
import droneCard from 'components/DroneCard/translations/english';
import droneComponentsTab from 'components/DroneDetailsDrawer/components/DroneComponentsTab/translations/english';
import droneHealthTab from 'components/DroneDetailsDrawer/components/DroneHealthTab/translations/english';
import logServiceFormFields from 'components/DroneDetailsDrawer/components/DroneServiceLogTab/components/LogServiceForm/components/LogServiceFormFields/translations/english';
import logServiceForm from 'components/DroneDetailsDrawer/components/DroneServiceLogTab/components/LogServiceForm/translations/english';
import serviceLogEntry from 'components/DroneDetailsDrawer/components/DroneServiceLogTab/components/ServiceLogEntry/translations/english';
import serviceLogHistory from 'components/DroneDetailsDrawer/components/DroneServiceLogTab/components/ServiceLogHistory/translations/english';
import droneServiceLogTab from 'components/DroneDetailsDrawer/components/DroneServiceLogTab/translations/english';
import droneDetailsDrawer from 'components/DroneDetailsDrawer/translations/english';
import dronesGrid from 'components/DronesGrid/translations/english';
import dronesToolbar from 'components/DronesToolbar/translations/english';
import dropZone from 'components/DropZone/translations/english';
import exportDropdownTrigger from 'components/ExportDropdown/components/ExportDropdownTrigger/translations/english';
import exportDropdown from 'components/ExportDropdown/translations/english';
import farmsGrid from 'components/FarmsGrid/translations/english';
import faults from 'components/Faults/translations/english';
import fieldsGrid from 'components/FieldsGrid/translations/english';
import flightsGridRow from 'components/FlightsGrid/components/FlightsGridRow/translations/english';
import flightsGrid from 'components/FlightsGrid/translations/english';
import floatingResourceAddMenu from 'components/FloatingResourceAddMenu/translations/english';
import formDiscardConfirmationPanel from 'components/FormDiscardConfirmationPanel/translations/english';
import formErrors from 'components/FormSubmitPanel/translations/english';
import healthCharts from 'components/HealthCharts/translations/english';
import validateDrawing from 'components/Map/hooks/useDrawingTool/hooks/useValidateDrawing/translations/english';
import map from 'components/Map/translations/english';
import mapAddressSearch from 'components/MapAddressSearch/translations/english';
import mapBoundaryPopover from 'components/MapBoundaryPopover/translations/english';
import mapControlPopup from 'components/MapControlPopup/translations/english';
import mapControlResetPopup from 'components/MapControlResetPopup/translations/english';
import drawControls from 'components/MapHorizontalControlBar/components/DrawControls/translations/english';
import drawingModeDropdown from 'components/MapHorizontalControlBar/components/DrawingModeDropdown/translations/english';
import drawingToolDropdown from 'components/MapHorizontalControlBar/components/DrawingToolDropdown/translations/english';
import pointModeDropdown from 'components/MapHorizontalControlBar/components/PointModeDropdown/translations/english';
import mapHorizontalControlBar from 'components/MapHorizontalControlBar/translations/english';
import mobileDrawerMenuButton from 'components/MobileDrawerMenuButton/translations/english';
import modal from 'components/Modal/translations/english';
import multiSelectPanel from 'components/MultiSelectPanel/translations/english';
import navigation from 'components/Navigation/translations/english';
import onboardingStepCount from 'components/OnboardingStepCount/translations/english';
import onboardingTopBar from 'components/OnboardingTopBar/translations/english';
import organizationDropdown from 'components/OrganizationDropdown/translations/english';
import searchFilters from 'components/SearchFilters/translations/english';
import selectPanel from 'components/SelectPanel/translations/english';
import selectableGrid from 'components/SelectableGrid/translations/english';
import serviceIntervalsButton from 'components/ServiceIntervalsButton/translations/english';
import serviceIntervalsModalFooter from 'components/ServiceIntervalsModal/components/ServiceIntervalsModalFooter/translations/english';
import serviceIntervalsModalPlaceholder from 'components/ServiceIntervalsModal/components/ServiceIntervalsModalPlaceholder/translations/english';
import serviceIntervalsModal from 'components/ServiceIntervalsModal/translations/english';
import singleSelectPanel from 'components/SingleSelectPanel/translations/english';
import usersGrid from 'components/UsersGrid/translations/english';
import withSplitView from 'components/WithSplitView/translations/english';
import cautionStatusBadge from 'components/badges/CautionStatusBadge/translations/english';
import criticalStatusBadge from 'components/badges/CriticalStatusBadge/translations/english';
import goodStatusBadge from 'components/badges/GoodStatusBadge/translations/english';
import groundedStatusBadge from 'components/badges/GroundedStatusBadge/translations/english';
import holdStatusBadge from 'components/badges/HoldStatusBadge/translations/english';
import readyStatusBadge from 'components/badges/ReadyStatusBadge/translations/english';
import addButton from 'components/buttons/AddButton/translations/english';
import cancelButton from 'components/buttons/CancelButton/translations/english';
import floatingResourceContainerFooter from 'components/containers/FloatingResourceContainerFooter/translations/english';
import onboardingFormContainer from 'components/containers/OnboardingFormContainer/translations/english';
import addressOneField from 'components/fields/AddressOneField/translations/english';
import addressTwoField from 'components/fields/AddressTwoField/translations/english';
import applicationNameField from 'components/fields/ApplicationNameField/translations/english';
import applicationSelectPanelField from 'components/fields/ApplicationSelectPanelField/translations/english';
import batteryMultiSelectPanelField from 'components/fields/BatteryMultiSelectPanelField/translations/english';
import batteryNameField from 'components/fields/BatteryNameField/translations/english';
import batterySerialNumberField from 'components/fields/BatterySerialNumberField/translations/english';
import boundaryMultiSelectPanelField from 'components/fields/BoundaryMultiSelectPanelField/translations/english';
import boundaryNameField from 'components/fields/BoundaryNameField/translations/english';
import boundarySelectPanelField from 'components/fields/BoundarySelectPanelField/translations/english';
import calibrationKindSelectPanelField from 'components/fields/CalibrationKindSelectPanelField/translations/english';
import cityField from 'components/fields/CityField/translations/english';
import clientComboBoxField from 'components/fields/ClientComboBoxField/translations/english';
import clientNameField from 'components/fields/ClientNameField/translations/english';
import clientSelectPanelField from 'components/fields/ClientSelectPanelField/translations/english';
import contactNameField from 'components/fields/ContactNameField/translations/english';
import droneMultiSelectPanelField from 'components/fields/DroneMultiSelectPanelField/translations/english';
import droneNameField from 'components/fields/DroneNameField/translations/english';
import emailAddressField from 'components/fields/EmailAddressField/translations/english';
import eventTypeField from 'components/fields/EventTypeField/translations/english';
import faaNumberField from 'components/fields/FaaNumberField/translations/english';
import farmNameField from 'components/fields/FarmNameField/translations/english';
import farmSelectPanelField from 'components/fields/FarmSelectPanelField/translations/english';
import fieldNameField from 'components/fields/FieldNameField/translations/english';
import fieldSelectPanelField from 'components/fields/FieldSelectPanelField/translations/english';
import firstNameField from 'components/fields/FirstNameField/translations/english';
import lastNameField from 'components/fields/LastNameField/translations/english';
import multiSelectBatteryField from 'components/fields/MultiSelectBatteryField/translations/english';
import multiSelectBoundaryField from 'components/fields/MultiSelectBoundaryField/translations/english';
import multiSelectDroneField from 'components/fields/MultiSelectDroneField/translations/english';
import multiSelectPilotField from 'components/fields/MultiSelectPilotField/translations/english';
import multiSelectRoleField from 'components/fields/MultiSelectRoleField/translations/english';
import notesField from 'components/fields/NotesField/translations/english';
import organizationNameField from 'components/fields/OrganizationNameField/translations/english';
import partSelectPanelField from 'components/fields/PartSelectPanelField/translations/english';
import phoneNumberField from 'components/fields/PhoneNumberField/translations/english';
import pilotMultiSelectPanelField from 'components/fields/PilotMultiSelectPanelField/translations/english';
import primaryBoundarySelectPanelField from 'components/fields/PrimaryBoundarySelectPanelField/translations/english';
import roleMultiSelectPanelField from 'components/fields/RoleMultiSelectPanelField/translations/english';
import selectApplicationField from 'components/fields/SelectApplicationField/translations/english';
import selectBoundaryField from 'components/fields/SelectBoundaryField/translations/english';
import selectCalibrationKindField from 'components/fields/SelectCalibrationKindField/translations/english';
import selectClientFarmField from 'components/fields/SelectClientFarmField/translations/english';
import selectClientFarmFieldField from 'components/fields/SelectClientFarmFieldField/translations/english';
import selectClientField from 'components/fields/SelectClientField/translations/english';
import selectFarmField from 'components/fields/SelectFarmField/translations/english';
import selectFieldField from 'components/fields/SelectFieldField/translations/english';
import selectPartField from 'components/fields/SelectPartField/translations/english';
import selectPrimaryBoundaryField from 'components/fields/SelectPrimaryBoundaryField/translations/english';
import selectUnitField from 'components/fields/SelectUnitField/translations/english';
import serviceDateField from 'components/fields/ServiceDateField/translations/english';
import serviceIntervalField from 'components/fields/ServiceIntervalField/translations/english';
import servicePhotosField from 'components/fields/ServicePhotosField/translations/english';
import statesDropdownField from 'components/fields/StatesDropdownField/translations/english';
import unitSelectPanelField from 'components/fields/UnitSelectPanelField/translations/english';
import zipCodeField from 'components/fields/ZipCodeField/translations/english';
import addressForm from 'components/forms/AddressForm/translations/english';
import applicationFormFields from 'components/forms/ApplicationFormFields/translations/english';
import batteryFormFields from 'components/forms/BatteryFormFields/translations/english';
import boundaryFormFields from 'components/forms/BoundaryFormFields/translations/english';
import clientFormFields from 'components/forms/ClientFormFields/translations/english';
import createApplicationForm from 'components/forms/CreateApplicationForm/translations/english';
import createBatteryForm from 'components/forms/CreateBatteryForm/translations/english';
import createBoundaryForm from 'components/forms/CreateBoundaryForm/translations/english';
import createClientForm from 'components/forms/CreateClientForm/translations/english';
import createDroneForm from 'components/forms/CreateDroneForm/translations/english';
import createFarmForm from 'components/forms/CreateFarmForm/translations/english';
import createFieldForm from 'components/forms/CreateFieldForm/translations/english';
import droneFormFields from 'components/forms/DroneFormFields/translations/english';
import farmFormFields from 'components/forms/FarmFormFields/translations/english';
import fieldBoundaryFields from 'components/forms/FieldBoundaryFields/translations/english';
import fieldFormFields from 'components/forms/FieldFormFields/translations/english';
import inviteUserForm from 'components/forms/InviteUserForm/translations/english';
import assetModelSelector from 'components/forms/ServiceIntervalsForm/components/AssetModelSelector/translations/english';
import serviceIntervalFields from 'components/forms/ServiceIntervalsForm/components/ServiceIntervalFields/translations/english';
import serviceIntervalsForm from 'components/forms/ServiceIntervalsForm/translations/english';
import updateApplicationForm from 'components/forms/UpdateApplicationForm/translations/english';
import updateBatteryForm from 'components/forms/UpdateBatteryForm/translations/english';
import updateBoundaryForm from 'components/forms/UpdateBoundaryForm/translations/english';
import updateClientForm from 'components/forms/UpdateClientForm/translations/english';
import updateDroneForm from 'components/forms/UpdateDroneForm/translations/english';
import updateFarmForm from 'components/forms/UpdateFarmForm/translations/english';
import updateFieldForm from 'components/forms/UpdateFieldForm/translations/english';
import updateUserForm from 'components/forms/UpdateUserForm/translations/english';
import userFormFields from 'components/forms/UserFormFields/translations/english';
import errorNotification from 'components/notifications/ErrorNotification/translations/english';
import applicationsTable from 'components/tables/ApplicationsTable/translations/english';
import assetsTable from 'components/tables/AssetsTable/translations/english';
import boundariesTable from 'components/tables/BoundariesTable/translations/english';
import clientsTable from 'components/tables/ClientsTable/translations/english';
import fieldsTable from 'components/tables/FieldsTable/translations/english';
import usersTable from 'components/tables/UsersTable/translations/english';

import useApplication from 'hooks/useApplication/translations/english';
import useApplications from 'hooks/useApplications/translations/english';
import useAssetModels from 'hooks/useAssetModels/translations/english';
import useAssetParts from 'hooks/useAssetParts/translations/english';
import useAssets from 'hooks/useAssets/translations/english';
import useBatteries from 'hooks/useBatteries/translations/english';
import useBattery from 'hooks/useBattery/translations/english';
import useBoundaries from 'hooks/useBoundaries/translations/english';
import useBoundary from 'hooks/useBoundary/translations/english';
import useBoundaryPanelItems from 'hooks/useBoundaryPanelItems/translations/english';
import useBoundarySections from 'hooks/useBoundarySections/translations/english';
import useChildCreation from 'hooks/useChildCreation/translations/english';
import useClient from 'hooks/useClient/translations/english';
import useClients from 'hooks/useClients/translations/english';
import useDrone from 'hooks/useDrone/translations/english';
import useDrones from 'hooks/useDrones/translations/english';
import useFarm from 'hooks/useFarm/translations/english';
import useFarms from 'hooks/useFarms/translations/english';
import useFetch from 'hooks/useFetch/translations/english';
import useField from 'hooks/useField/translations/english';
import useFields from 'hooks/useFields/translations/english';
import useFlights from 'hooks/useFlights/translations/english';
import useOrganizations from 'hooks/useOrganizations/translations/english';
import usePartTypeLabels from 'hooks/usePartTypeLabels/translations/english';
import useServiceIntervals from 'hooks/useServiceIntervals/translations/english';
import useServiceLog from 'hooks/useServiceLog/translations/english';
import useServiceLogs from 'hooks/useServiceLogs/translations/english';
import useUser from 'hooks/useUser/translations/english';
import useUsers from 'hooks/useUsers/translations/english';

import applicationDetailsPage from 'pages/ApplicationDetailsPage/translations/english';
import batteryDetailsPage from 'pages/BatteryDetailsPage/translations/english';
import boundaryDetailPage from 'pages/BoundaryDetailPage/translations/english';
import clientDetailsPage from 'pages/ClientDetailsPage/translations/english';
import dataPage from 'pages/DataPage/translations/english';
import droneDetailsPage from 'pages/DroneDetailsPage/translations/english';
import farmDetailsPage from 'pages/FarmDetailsPage/translations/english';
import fieldDetailsPage from 'pages/FieldDetailsPage/translations/english';
import maintenancePage from 'pages/MaintenancePage/translations/english';
import onboardingCurrentUserPage from 'pages/OnboardingCurrentUserPage/translations/english';
import onboardingOrganizationCreationPage from 'pages/OnboardingOrganizationCreation/translations/english';
import reportsPage from 'pages/ReportsPage/translations/english';
import userDetailsPage from 'pages/UserDetailsPage/translations/english';
import verifyEmailPage from 'pages/VerifyEmailPage/translations/english';

export const TRANSLATIONS_EN = {
    activityCardHeader,
    addButton,
    addressForm,
    addressOneField,
    addressTwoField,
    applicationActivityList,
    applicationDetailsPage,
    applicationFormFields,
    applicationNameField,
    applicationSelectPanelField,
    applicationsGrid,
    applicationsGridRow,
    applicationsTable,
    assetModelSelector,
    assetToggle,
    assetsGrid,
    assetsGridRow,
    assetsTable,
    batteriesGrid,
    batteryCard,
    batteryDetailsPage,
    batteryFormFields,
    batteryMultiSelectPanelField,
    batteryNameField,
    batterySerialNumberField,
    boundariesGrid,
    boundariesTable,
    boundaryDetailPage,
    boundaryFormFields,
    boundaryMultiSelectPanelField,
    boundaryNameField,
    boundarySelectPanelField,
    calibrationKindSelectPanelField,
    cancelButton,
    cautionStatusBadge,
    cityField,
    clientComboBoxField,
    clientDetailsPage,
    clientFormFields,
    clientGrid,
    clientNameField,
    clientSelectPanelField,
    clientsTable,
    combobox,
    componentStatusRow,
    contactNameField,
    createApplicationForm,
    createBatteryForm,
    createBoundaryForm,
    createClientForm,
    createDroneForm,
    createFarmForm,
    createFieldForm,
    criticalStatusBadge,
    dataPage,
    dataTableDropdown,
    datePicker,
    dateRangePicker,
    dateRangePickerInputs,
    detailsViewCardApplicationList,
    detailsViewCardApplicationListItem,
    detailsViewCloseButton,
    detailsViewEntityMenu,
    drawControls,
    drawer,
    drawingModeDropdown,
    drawingToolDropdown,
    droneActivityLink,
    droneCard,
    droneCardDetails,
    droneComponentsTab,
    droneDetailsDrawer,
    droneDetailsPage,
    droneFormFields,
    droneHealthTab,
    droneMultiSelectPanelField,
    droneNameField,
    droneServiceLogTab,
    dronesGrid,
    dronesToolbar,
    dropZone,
    emailAddressField,
    errorNotification,
    eventTypeField,
    exportDropdown,
    exportDropdownTrigger,
    faaNumberField,
    farmDetailsPage,
    farmFormFields,
    farmNameField,
    farmSelectPanelField,
    farmsGrid,
    faults,
    fieldBoundaryFields,
    fieldDetailsPage,
    fieldFormFields,
    fieldNameField,
    fieldSelectPanelField,
    fieldsGrid,
    fieldsTable,
    firstNameField,
    flightsGrid,
    flightsGridRow,
    floatingResourceAddMenu,
    floatingResourceContainerFooter,
    formDiscardConfirmationPanel,
    formErrors,
    goodStatusBadge,
    groundedStatusBadge,
    healthCharts,
    holdStatusBadge,

    inviteUserForm,
    lastNameField,
    lastSynced,
    logServiceForm,
    logServiceFormFields,
    maintenancePage,
    map,
    mapAddressSearch,
    mapBoundaryPopover,
    mapControlPopup,
    mapControlResetPopup,
    mapHorizontalControlBar,
    mobileDrawerMenuButton,
    modal,
    multiSelectBatteryField,
    multiSelectBoundaryField,
    multiSelectDroneField,
    multiSelectPanel,
    multiSelectPilotField,
    multiSelectRoleField,
    navigation,
    notesField,
    onboardingCurrentUserPage,
    onboardingFormContainer,
    onboardingOrganizationCreationPage,
    onboardingStepCount,
    onboardingTopBar,
    organizationDropdown,
    organizationNameField,
    partSelectPanelField,
    phoneNumberField,
    pilotMultiSelectPanelField,
    pointModeDropdown,
    primaryBoundarySelectPanelField,
    readyStatusBadge,
    reportsPage,
    roleMultiSelectPanelField,
    searchFilters,
    selectApplicationField,
    selectBoundaryField,
    selectCalibrationKindField,
    selectClientFarmField,
    selectClientFarmFieldField,
    selectClientField,
    selectFarmField,
    selectFieldField,
    selectPanel,
    selectPartField,
    selectPrimaryBoundaryField,
    selectUnitField,
    selectableGrid,
    serviceDateField,
    serviceIntervalField,
    serviceIntervalFields,
    serviceIntervalsButton,
    serviceIntervalsForm,
    serviceIntervalsModal,
    serviceIntervalsModalFooter,
    serviceIntervalsModalPlaceholder,
    serviceLogEntry,
    serviceLogHistory,
    servicePhotosField,
    singleSelectPanel,
    statesDropdownField,
    unitSelectPanelField,
    updateApplicationForm,
    updateBatteryForm,
    updateBoundaryForm,
    updateClientForm,
    updateDroneForm,
    updateFarmForm,
    updateFieldForm,
    updateUserForm,
    useApplication,
    useApplications,
    useAssetModels,
    useAssetParts,
    useAssets,
    useBatteries,
    useBattery,
    useBoundaries,
    useBoundary,
    useBoundaryPanelItems,
    useBoundarySections,
    useChildCreation,
    useClient,
    useClients,
    useDrone,
    useDrones,
    useFarm,
    useFarms,
    useFetch,
    useField,
    useFields,
    useFlights,
    useOrganizations,
    usePartTypeLabels,
    useServiceIntervals,
    useServiceLog,
    useServiceLogs,
    useUser,
    useUsers,
    userDetailsPage,
    userFormFields,
    usersGrid,
    usersTable,
    validateDrawing,
    verifyEmailPage,
    withSplitView,
    zipCodeField
};
